import { render, staticRenderFns } from "./TestNameComponent.vue?vue&type=template&id=456f749b"
import script from "./TestNameComponent.vue?vue&type=script&lang=js"
export * from "./TestNameComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports